<template>
  <div>
    <button
      class="btn btn-danger mb-3"
      @click="$emit('setAksiSync', 0)"
    >
      <i class="fa fa-angle-left mr-2" />
      Kembali
    </button>
    <form
      id="file-upload-form"
      class="uploader"
    >
      <input
        id="file-upload"
        type="file"
        name="fileUpload"
        @change="selectFile"
        accept="v, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      >
      <label
        for="file-upload"
        id="file-drag"
      >
        <div
          v-if="!form.file"
          id="start"
        >
          <i
            class="fa fa-download"
            aria-hidden="true"
          />
          <div>Pilih file data penduduk dengan format .xls</div>
          <span
            id="file-upload-btn"
            class="btn btn-primary"
          >Pilih File</span>
        </div>

        <div
          v-else
          id="response"
        >
          <span>Memproses</span>
          <div id="messages" />
          <progress
            class="progress"
            id="file-progress"
            :value="uploadProgress"
          >
            <span>{{ uploadProgress }}</span>%
          </progress>
          <p class="text-center">{{ syncMessage }}</p>
        </div>
      </label>
    </form>
  </div>
</template>


<style scoped>
	.uploader {
		display: block;
		clear: both;
		width: 100%;
		max-width: 600px;
	}
	.uploader label {
		float: left;
		clear: both;
		width: 100%;
		padding: 2rem 1.5rem;
		text-align: center;
		background: #fff;
		border-radius: 7px;
		border: 3px solid #eee;
		transition: all 0.2s ease;
		-webkit-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
				user-select: none;
	}
	.uploader label:hover {
		border-color: #6777ef;
	}
	.uploader label.hover {
		border: 3px solid #6777ef;
		box-shadow: inset 0 0 0 6px #eee;
	}
	.uploader label.hover #start i.fa {
	transform: scale(0.8);
	opacity: 0.3;
	}
	.uploader #start {
	float: left;
	clear: both;
	width: 100%;
	}
	.uploader #start.hidden {
	display: none;
	}
	.uploader #start i.fa {
	font-size: 50px;
	margin-bottom: 1rem;
	transition: all 0.2s ease-in-out;
	}
	.uploader #response {
	float: left;
	clear: both;
	width: 100%;
	}
	.uploader #response.hidden {
	display: none;
	}
	.uploader #response #messages {
	margin-bottom: 0.5rem;
	}
	.uploader #file-image {
		display: inline;
		margin: 0 auto 0.5rem auto;
		width: auto;
		height: auto;
		max-width: 100px;
	}
	.uploader #file-image.hidden {
	display: none;
	}
	.uploader #notimage {
	display: block;
	float: left;
	clear: both;
	width: 100%;
	}
	.uploader #notimage.hidden {
	display: none;
	}
	.uploader progress,
	.uploader .progress {
		display: inline;
		clear: both;
		margin: 0 auto;
		width: 100%;
		max-width: 180px;
		height: 8px;
		border: 0;
		border-radius: 4px;
		background-color: #eee;
		overflow: hidden;
	}
	.uploader .progress[value]::-webkit-progress-bar {
		border-radius: 4px;
		background-color: #eee;
	}
	.uploader .progress[value]::-webkit-progress-value {
		background: #6777ef;
		border-radius: 4px;
	}
	.uploader .progress[value]::-moz-progress-bar {
		background: #6777ef;
		border-radius: 4px;
	}
	.uploader input[type=file] {
		display: none;
		/* opacity: 0;
		position: absolute;
		padding: 100px; */
	}
	.uploader div {
	margin: 0 0 0.5rem 0;
	color: #5f6982;
	}
	.uploader .btn {
		display: inline-block;
		margin: 0.5rem 0.5rem 1rem 0.5rem;
		clear: both;
		font-family: inherit;
		font-weight: 700;
		font-size: 14px;
		text-decoration: none;
		text-transform: initial;
		border: none;
		border-radius: 0.2rem;
		outline: none;
		padding: 0 1rem;
		height: 36px;
		line-height: 36px;
		color: #fff;
		transition: all 0.2s ease-in-out;
		box-sizing: border-box;
		background: #6777ef;
		border-color: #6777ef;
		cursor: pointer;
	}
</style>

<script>
import swal from 'sweetalert'
export default {
    data() {
        return {
			form: {
				file: null
			},
			uploadProgress: 0,
			syncMessage: '',
        }
    },
	methods: {
		selectFile(e){
			this.form.file = e.target.files[0]

			this.onSubmit()
		},
		uploadProgressAction(e){
			this.uploadProgress = e.loaded / e.total
			// console.log(this.uploadProgress)
			this.syncMessage = parseInt(this.uploadProgress * 100) + '%'
			if(this.uploadProgress === 1){
				setTimeout(() => {
					this.syncMessage = 'Sinkronisasi data...'
					this.$emit('setLoaderSinkronisasi', true)
				}, 2000)
			}
		},
		onSubmit(){
			let isBisaSync = true
			if(!isBisaSync){
				swal({
					title: "Tidak diizinkan",
					text: "Sinkronisasi Penduduk Belum Diizinkan",
					icon: "error",
					buttons: "Ok"
				})
				window.location = ''
				return false
			}
			if(!this.form.file){
				swal({
					title: "Gagal",
					text: "File kosong",
					icon: "error",
					buttons: "Ok"
				})
				return false
			}


			swal({
                title: "Yakin ingin sinkronisasi data?",
                text: "Proses sinkronisasi mungkin memakan waktu lama.",
                icon: "warning",
                buttons: {
                    cancel: "Batal",
                    ok: {
                        text: "Yakin, sinkronisasi sekarang",
                        value: "ok",
                    },
                }
            }).then( val => {
                if(val === 'ok'){
					this.$emit('setLoaderSinkronisasi', true)
					let formData = new FormData()
					formData.append('file', this.form.file)

					this.$store.dispatch('cekDataImportPenduduk', {data: formData, uploadProgress: this.uploadProgressAction}).then(response => {
						if(response.data.status){
							this.syncMessage = '100%'
							this.uploadProgress = 1

							setTimeout(() => {
								swal({
									title: "Berhasil",
									text: response.data.message,
									icon: "success",
									buttons: "Ok"
								})
								this.form.file = null
								this.aksiSync = 0
								this.loadRiwayat()

								this.$emit('setLoaderSinkronisasi', false)
							}, 500)
							
						} else {
							swal({
								title: "Gagal",
								text: response.data.message,
								icon: "error",
								buttons: "Ok"
							})
							window.location = ''
						}
					}).catch(error => {
						// console.log(error)
						switch(error.response.status){
							case 500:
								this.$router.push({path: '/500'})
								break;

							case 400:
								swal({
									title: "Gagal",
									text: (typeof(error.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : error.response.data.message,
									icon: "error",
									buttons: "Ok"
								})
								break;
							
							default:
								swal({
									title: "Gagal",
									text: error.response.data.message,
									icon: "error",
									buttons: "Ok"
								})
								break;
						}
					})
				} else {
					this.form.file = null
				}
			})
		}
	}
}
</script>